import { Component, computed, input } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-user-profile-picture',
  standalone: true,
  imports: [],
  templateUrl: './user-profile-picture.component.html',
  styleUrls: ['./user-profile-picture.component.scss'],
})
export class UserProfilePictureComponent {
  imageUrl = input<string | undefined | null>('');
  name = input<string>('');
  size = input<number>(35);

  private environment = environment.files;

  imagePath = computed(() => {
    const url = this.imageUrl()?.trim();
    return url ? this.environment + url : '';
  });

  width = computed(() => this.size());
  height = computed(() => this.size());
  fontSize = computed(() => this.size() / 2);

  initialLetter = computed(() => this.name()?.charAt(0).toUpperCase() || '');
}
